<template>
  <span id="filtermapactive" class="filter-map-active">
      <label class="switch">
        <input name="filtermapactive" type="checkbox" v-on:change="set" :checked="get">
        <div class="slider round"></div>
      </label>
  </span>
</template>

<script>
export default {
  name: 'filterMapActive',

  methods: {
    set (e) {
      this.$store.dispatch('filterMapActive/set', +e.target.checked)
    }
  },

  computed: {
    get () {
      return this.$store.getters['filterMapActive/get']
    }
  }
}
</script>

<style lang="scss">
@import "./src/sass/components/FilterMapActive";
@import "./src/sass/switch";
</style>



// WEBPACK FOOTER //
// FilterMapActive.vue?321db34e